export default [
    {
        name: 'Weapons',
        weight: 500,
        items: [
            {name: 'MLRS Platform', weight: 240000},

            {name: 'Multiple Grenade Launcher', weight: 6000},

            {name: 'M249 SAW', weight: 5000},

            {name: 'Flare Gun', weight: 3000},

            {name: 'L96', weight: 1400},

            {name: 'LR-300', weight: 1200},
			{name: 'M39', weight: 1200},

            {name: 'AK (Assault Rifle)', weight: 1000},
            {name: 'Rocket Launcher', weight: 1000},

            {name: 'SPAS 12G', weight: 800},
            {name: 'MP5A4 SMG', weight: 800},

            {name: 'Bolt-Action Rifle', weight: 600},
            {name: 'M92 Pistol', weight: 600},
            {name: 'Thompson SMG', weight: 600},

            {name: 'Custom SMG', weight: 400},
            {name: 'Pump-Action 12G', weight: 400},
            {name: 'Python', weight: 400},
            {name: 'Semi-Auto Rifle', weight: 400},
            {name: 'Flame Thrower', weight: 400},
            {name: 'Double-Barrel 12G', weight: 400},
            {name: 'Nailgun', weight: 400},
            {name: 'Semi-Auto Pistol', weight: 400},

            {name: 'Crossbow', weight: 200},
            {name: 'Compound Bow', weight: 200},
            {name: 'Revolver', weight: 200},
            {name: 'Waterpipe', weight: 200},

            {name: 'Hunting Bow', weight: 100},
            {name: 'Combat Knife', weight: 100},
            {name: 'Salvaged Hammer', weight: 100},
        ]
    },
    {
        name: 'Attachments',
        weight: 10,
        items: [
            {name: '16x', weight: 4000},
            {name: 'Silencer', weight: 4000},

            {name: '8x', weight: 2000},
            {name: 'Laser', weight: 2000},
            {name: 'Holo', weight: 2000},

            {name: 'Handmade', weight: 1000},
            {name: 'Boost', weight: 1000},
            {name: 'Break', weight: 1000},
            {name: 'Flashlight', weight: 1000},
        ]
    },
    {
        name: 'Ammo',
        weight: 1,
        items: [
            {name: 'Smoke Rocket', weight: 300000},

            {name: 'Smoke Grenade', weight: 7500},

            {name: '40mm Smoke', weight: 3000},

            {name: '40mm Smoke', weight: 1500},

            {name: '12G Incendiary', weight: 600},

            {name: 'Fire Arrow', weight: 500},

            {name: '5.56 Explosive', weight: 400},
            
            {name: '12G Slug', weight: 300},
            {name: '5.56 Incendiary', weight: 300},
            {name: '5.56 HV', weight: 300},

            {name: '12G Buckshot', weight: 200},
            {name: '5.56 Regular', weight: 200},
            {name: 'Pistol Incendiary', weight: 200},

            {name: 'Pistol HV', weight: 150},

            {name: 'Pistol Regular', weight: 100},

            {name: 'HV Arrow', weight: 50},
            {name: 'Wooden Arrow', weight: 50},
            {name: 'Bone Arrow', weight: 50},
            {name: 'Handmade Shell', weight: 50},
            {name: 'Nail', weight: 50},
        ]
    },
    {
        name: 'Explosives',
        weight: 3000,
        items: [
            {name: 'Flare', weight: 240},

            {name: 'C4', weight: 80},

            {name: 'Basic Rocket', weight: 40},

            {name: 'Incendiary Rocket', weight: 20},

            {name: 'HV Rocket', weight: 10},

            {name: 'F1 Grenade', weight: 5},

            {name: '40mm HE', weight: 3}           
        ]
    },
    {
        name: 'Meds',
        weight: 10,
        items: [
            {name: 'Pure Max Health Tea', weight: 125000},

            {name: 'Pure Healing Tea', weight: 600},
            {name: 'Medkit', weight: 600},

            {name: 'Medical Syringe', weight: 400},

            {name: 'Blueberries', weight: 100},
            {name: 'Blackberries', weight: 100},
        ]
    },
    {
        name: 'Attire',
        weight: 50,
        items: [
            {name: 'Heavy Scientist Suit', weight: 25000},
            {name: 'Barrel Costume', weight: 25000},
            {name: 'Crate Costume', weight: 25000},

            {name: 'Ghost Costume', weight: 15000},

            {name: 'Headset', weight: 5000},
            {name: 'NVGs', weight: 5000},
            {name: 'Frog Boots', weight: 5000},
            {name: 'Wetsuit', weight: 5000},
            {name: 'Diving Fins', weight: 5000},
            {name: 'Diving Tank', weight: 5000},
            {name: 'Diving Mask', weight: 5000},

            {name: 'Scientist Suit (Green)', weight: 3000},
            {name: 'Scientist Suit (Blue)', weight: 3000},
            {name: 'Hazmat', weight: 3000},
            
            {name: 'HP Jacket', weight: 2000},
            {name: 'HP Helmet', weight: 2000},
            {name: 'HP Pants', weight: 2000},

            {name: 'Chest Plate', weight: 1500},
            {name: 'Facemask', weight: 1500},

            {name: 'Tactical Gloves', weight: 1000},

            {name: 'Road Sign Kilt', weight: 500},

            {name: 'Boots', weight: 100},
            {name: 'Pants', weight: 100},
            {name: 'Hoodie', weight: 100},

            {name: 'Bandana Mask', weight: 50},

            {name: 'Glowing Eyes', weight: 25},
            {name: 'Mustache', weight: 25},
        ]
    },
    {
        name: 'Construction',
        weight: 50,
        items: [
            {name: 'HE Gate', weight: 2500},

            {name: 'Garage Door', weight: 2000},
            {name: 'Double Armored Door', weight: 2000},

            {name: 'Armored Door', weight: 1000},

            {name: 'Ladder Hatch', weight: 500},
            {name: 'Triangle Ladder Hatch', weight: 500},

            {name: 'Stone High Wall', weight: 150},
            {name: 'Ice High Wall', weight: 150},

            {name: 'Ladder', weight: 100},

            {name: 'Wooden High Wall', weight: 80},

            {name: 'Wooden Cover', weight: 75},
            {name: 'Reinforced Window Bars', weight: 75},
            {name: 'Metal Barricade', weight: 75},
            {name: 'Horizontal Embrasure', weight: 75},
            {name: 'Vertical Embrasure', weight: 75},
        ]
    },
    {
        name: 'Traps',
        weight: 50,
        items: [
            {name: 'SAM Site', weight: 50000},

            {name: 'Auto Turret', weight: 15000},

            {name: 'Shotgun Trap', weight: 7500},

            {name: 'Flame Turret', weight: 5000},

            {name: 'Land Mine', weight: 500},

            {name: 'Snap Trap', weight: 100},

            {name: 'Floor Spikes', weight: 10},
        ]
    },
    {
        name: 'Resources',
        weight: 2,
        items: [
            {name: 'Battery', weight: 750000},

            {name: 'Rifle Body', weight: 175000},

            {name: 'Duct Tape', weight: 75000},
            {name: 'SMG Body', weight: 75000},

            {name: 'Semi Body', weight: 50000},

            {name: 'Glue', weight: 30000},
            {name: 'Tech Trash', weight: 30000},

            {name: 'Gears', weight: 16000},
			{name: 'Tarp', weight: 16000},

            {name: 'Bleach', weight: 15000},

            {name: 'Metal Springs', weight: 7000},

            {name: 'Metal Pipes', weight: 5000},

            {name: 'Sewing Kit', weight: 2000},

            {name: 'Rope', weight: 1000},

            {name: 'Scrap', weight: 500},

            {name: 'HQM', weight: 250},

            {name: 'Low Grade', weight: 100},

            {name: 'Metal Frags', weight: 10},

            {name: 'Leather', weight: 5},
            {name: 'Cloth', weight: 5},

            {name: 'Stone', weight: 2},

            {name: 'Wood', weight: 1},
        ]
    },

]
